<template>
  <Button :loading="loading" @click.prevent="onClick" v-bind="$attrs">
    <slot></slot>
  </Button>
</template>
<script>
  import debounce from 'lodash/debounce';
  export default {
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      onClick: debounce(
        function() {
          this.loading = true;
          this.$emit('click', this.resetLoading);
        },
        400,
        {
          leading: true,
          trailing: false
        }
      ),
      // 恢复
      resetLoading() {
        this.loading = false;
      },
    },
  };
</script>
